"use strict";

const _ = require('lodash');

const config = require('../shared/config');
const APIController = require('../shared/api-controller');
const toggles = require('./toggles');
const {getFieldName, getFieldTitle} = require('../shared/utils');

class FiltersToggles extends toggles.AsteriskToggles {
}

class FiltersTogglesController extends toggles.PopupToggles {
	constructor(options) {
		super(Object.assign({coloured: false, itemKey: 'value'}, options));
	}

	getQueryParams() {
		let asterisk = this.toggles.getToggle('*');
		if (!asterisk || asterisk.isOn) { return {}; }
		return super.getQueryParams();
	}

	getInfoContent() {
		let asterisk = this.toggles.getToggle('*');
		if (!asterisk || asterisk.isOn) {
			return 'All';
		}
		return super.getInfoContent();
	}

	reset() {
		this.toggles.asterisk();
		this.redraw({}, _.noop);
	}

	getItems() {
		let asterisk = this.toggles.getToggle('*');
		if (!asterisk || asterisk.isOn) {
			return [];
		}
		return Array.from(this.toggles.toggledOn(this.options.itemKey));
	}
}

const FILTERS_HASH_TEMPLATE = require('../templates/filters-hash.html');
class FiltersHashController extends APIController {
	constructor(options) {
		options = Object.assign({
			filters: config.get('Filters'),
			method: 'filters/values',
			dataField: 'fields'
		}, options);
		super(options);
		this._template = FILTERS_HASH_TEMPLATE;
		this._toggles = new Map();
		this._controllers = new Map();
		let self = this;
		let forwardUpdateEvent = function () { self.emit('cm:update', self); };
		for (let f of this.fields()) {
			let toggles = new FiltersToggles();
			let controller = new FiltersTogglesController({queryKey: f, toggles});
			controller.on('cm:update', forwardUpdateEvent);
			this._toggles.set(f, toggles);
			this._controllers.set(f, controller);
		}
	}

	* filters() {
		let {filters} = this.options;
		for (let f of filters) {
			yield [getFieldName(f), getFieldTitle(f)];
		}
	}

	* fields() {
		let {filters} = this.options;
		for (let f of filters) {
			yield getFieldName(f);
		}
	}

	getApiCallOptions(options) {
		options = super.getApiCallOptions(options);
		options.params = {fields: [... this.fields()]};
		options.merge = false;
		return options;
	}

	processResponse(response) {
		let fields = {};
		let dataField = this.options.dataField;
		for (let api of Object.keys(response)) {
			let r = _.get(response, `${api}.${dataField}`);
			if (!r) {
				continue;
			}
			// Merge environments (with filtering and remapping)
			// fields.environment = _.union(fields.environment, client.filterEnvironments(r.environment));
			// Merge rest of the fields
			for (let f of Object.keys(r)) {
				fields[f] = _.union(fields[f], r[f]);
			}
		}

		this.options.data = fields;
		for (let [f, toggles] of this._toggles.entries()) {
			toggles.update(fields[f]);
		}
		return response;
	}

	getRenderOptions(options) {
		options = super.getRenderOptions(options);
		options.filters = [... this.filters()];
		return options;
	}

	render(options) {
		let self = this;
		return super.render(options)
			.then(function (options) {
				let dom = self.container;
				let tasks = [];
				for (let [f, controller] of self._controllers) {
					let container = dom.querySelector(`[data-controller="${f}"]`);
					if (container) {
						tasks.push(controller.render({container}));
					}
				}
				return Promise.all(tasks)
					.then(function () {
						return options;
					});
			});
	}

	reload(options) {
		// Don't
		return Promise.resolve(options);
	}

	getQueryParams() {
		let r = Object.create(null);
		for (let c of this._controllers.values()) {
			Object.assign(r, c.getQueryParams());
		}
		return r;
	}

	formatInfoItem(item) {
		return `<span>${item}</span>`;
	}

	getInfoContent() {
		let items = [];
		for (let c of this._controllers.values()) {
			items.push(... c.getItems());
		}
		if (!items.length) {
			return 'All';
		} else {
			return items.map(this.formatInfoItem).join(', ');
		}
	}

	reset() {
		for (let c of this._controllers.values()) {
			c.reset();
		}
	}
}

module.exports = FiltersHashController;
FiltersHashController.FiltersToggles = FiltersToggles;
FiltersHashController.FiltersTogglesController = FiltersTogglesController;